/**
 * Form validation utilities for boat listing forms
 */

/**
 * Validate pricing fields for boat listings
 * @param {Object} pricing - The pricing object to validate
 * @returns {Object} - Object containing validation errors, if any
 */
export const validatePricingFields = (pricing) => {
  const errors = {};

  // Validate hourly rate
  if (!pricing.hourlyRate || pricing.hourlyRate <= 0) {
    errors.hourlyRate = 'Hourly rate is required and must be greater than 0';
  }

  // Validate max passengers
  if (!pricing.maxPassengers || pricing.maxPassengers <= 0) {
    errors.maxPassengers = 'Max passengers is required and must be greater than 0';
  }

  // Validate additional passengers allowed
  if (pricing.additionalPassengersAllowed < 0) {
    errors.additionalPassengersAllowed = 'Additional passengers allowed must be 0 or greater';
  }

  // Validate additional passenger percentage
  if (pricing.additionalPassengerPercentage < 0) {
    errors.additionalPassengerPercentage = 'Additional passenger percentage must be 0 or greater';
  }

  // Validate hourly options
  if (pricing.hourlyOptions && pricing.hourlyOptions.length > 0) {
    const hourlyOptionErrors = [];
    
    pricing.hourlyOptions.forEach((option, index) => {
      const optionErrors = {};
      
      if (!option.hours || option.hours <= 0) {
        optionErrors.hours = 'Hours is required and must be greater than 0';
      }
      
      if (!option.price || option.price <= 0) {
        optionErrors.price = 'Price is required and must be greater than 0';
      }
      
      if (!option.maxPassengers || option.maxPassengers <= 0) {
        optionErrors.maxPassengers = 'Max passengers is required and must be greater than 0';
      }
      
      if (option.additionalPassengersAllowed < 0) {
        optionErrors.additionalPassengersAllowed = 'Additional passengers allowed must be 0 or greater';
      }
      
      if (option.additionalPassengerPercentage < 0) {
        optionErrors.additionalPassengerPercentage = 'Additional passenger percentage must be 0 or greater';
      }
      
      if (Object.keys(optionErrors).length > 0) {
        hourlyOptionErrors[index] = optionErrors;
      }
    });
    
    if (hourlyOptionErrors.length > 0) {
      errors.hourlyOptions = hourlyOptionErrors;
    }
  }

  // Validate daily options
  if (pricing.dailyOptions && pricing.dailyOptions.length > 0) {
    const dailyOptionErrors = [];
    
    pricing.dailyOptions.forEach((option, index) => {
      const optionErrors = {};
      
      if (!option.days || option.days <= 0) {
        optionErrors.days = 'Days is required and must be greater than 0';
      }
      
      if (!option.price || option.price <= 0) {
        optionErrors.price = 'Price is required and must be greater than 0';
      }
      
      if (Object.keys(optionErrors).length > 0) {
        dailyOptionErrors[index] = optionErrors;
      }
    });
    
    if (dailyOptionErrors.length > 0) {
      errors.dailyOptions = dailyOptionErrors;
    }
  }

  return errors;
};

/**
 * Check if pricing fields have validation errors
 * @param {Object} pricing - The pricing object to validate
 * @returns {boolean} - True if there are validation errors, false otherwise
 */
export const hasPricingErrors = (pricing) => {
  const errors = validatePricingFields(pricing);
  return Object.keys(errors).length > 0;
};
